/**
 * PD-7364: On the homepage, redirect a logged-in variant user to their last live city list once per browser session.
 *
 * @see https://firsttable.atlassian.net/browse/PD-7364
 * @see https://app.growthbook.io/features/pd-7364-redirect-logged-in-users-from-homepage
 * @see https://app.growthbook.io/experiment/exp_19g6dmviu8rxu
 */
export const PD7364_REDIRECT_LOGGED_IN_USERS_FROM_HOMEPAGE_FLAG =
  'pd-7364-redirect-logged-in-users-from-homepage';
